import PropTypes from 'prop-types'
import React from 'react'
import ResponsiveDataTable from '../../ResponsiveDataTable'
import useColumns from './useColumns'

const LargeBillsTable = ({bills, isLoading, onSelectPayee, onSort}) => {
  const {columns} = useColumns({onSelectPayee})

  return (
    <ResponsiveDataTable
      className="fs-unmask"
      columns={columns}
      data={bills}
      isLoading={isLoading}
      onSort={onSort}
      enableSorting
      variant="sm"
    />
  )
}

LargeBillsTable.propTypes = {
  bills: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onSelectPayee: PropTypes.func.isRequired,
  onSort: PropTypes.func.isRequired,
}

export default LargeBillsTable
